import { getUserClaims, type UserClaims } from '~/lib/auth'

import { useQuery } from '@tanstack/react-query'

/**
 * ログイン状態（Cognito の ID トークンのクレーム）。GuardAuth とログイン画面で共有する。
 *
 * ログインに成功したら、必ず queryClient.setQueryData(AUTH_CLAIMS_QUERY_KEY, claims) で
 * キャッシュを書き換えること。ログイン前に「未ログイン（null）」を一度キャッシュしているので、
 * そのままだと staleTime の間は古い null が使われ、ログイン直後にまたログイン画面へ戻される。
 */
export const AUTH_CLAIMS_QUERY_KEY = ['auth-claims'] as const

export function useAuthClaims(): { claims: UserClaims | null; isChecking: boolean } {
  const query = useQuery({
    queryKey: AUTH_CLAIMS_QUERY_KEY,
    queryFn: () => getUserClaims(),
    retry: false,
    // 画面遷移のたびに Cognito を叩かないようにする。
    staleTime: 5 * 60 * 1000,
  })
  return {
    claims: query.data ?? null,
    // ⚠️ react-query は v4。v5 の isPending は存在せず常に undefined になるので使わない。
    isChecking: query.isLoading,
  }
}
